export default __webpack_public_path__ + "static/media/AFTIM-img-5.dee25302.jpg";